import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { gotoNewPage } from '@src/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import { formatImageWebpAuto } from '@ifeng/public_method';
import 'swiper/css';
import 'swiper/css/pagination';

const Layout = ({ content }) => {
    console.log(content);

    return (
        <div>
            {content.length && content.length === 1 ? (
                <div className={styles.ad} onClick={gotoNewPage({ url: content[0].url, type: 'web' })}>
                    <img src={content[0].postImage} className={styles.adimg} />
                </div>
            ) : (
                <div className={styles.ad}>
                    <Swiper
                        grabCursor={true}
                        loop={true}
                        modules={[Autoplay, Pagination]}
                        key="swiper"
                        autoplay={true}
                        className={styles.adimg}
                        speed={2000}
                        pagination={{ clickable: true, bulletClass: 'bullet', bulletActiveClass: 'bulletActive', el: '.swiper-pagination' }}>
                        {content.map((item, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <div className={styles.swiperItem} onClick={gotoNewPage({ url: item.url, type: 'web' })}>
                                        <img src={item.postImage} className={styles.adimg} />
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                        <div className="swiper-pagination" />
                    </Swiper>
                </div>
            )}
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.array,
};

export default errorBoundary(Layout);
